import { useMemo } from 'react'

import { useApiReactQuery } from '@/api/useApiWithReactQuery'
import { TRENDING_DESTINATIONS_QUERY_KEY } from '@partment/types'

const getTrendingOrder = (location) => {
  const parsedOrder = Number(location?.trending_order)

  return Number.isFinite(parsedOrder) ? parsedOrder : Number.MAX_SAFE_INTEGER
}

const normalizeLocationOption = (location) => ({
  ...location,
  id: location?.cityId ?? location?.id,
  cityId: location?.cityId ?? location?.id,
  city: location?.city ?? location?.city_name ?? '',
  city_name: location?.city_name ?? location?.city ?? '',
  title: location?.title ?? location?.region ?? '',
  country: location?.country ?? '',
  imagePreview: location?.imagePreview ?? location?.image ?? null,
})

export const useLocation = () => {
  const { get, error } = useApiReactQuery()

  const {
    data,
    isLoading: loading,
    isError,
  } = get(
    [TRENDING_DESTINATIONS_QUERY_KEY],
    '/vacation-rental/trending-destination/city',
    false,
    'v2',
  )

  const cities = useMemo(() => {
    if (!data) {
      return data
    }

    const normalizedLocations = Array.isArray(data?.data)
      ? data.data
          .map(normalizeLocationOption)
          .filter(
            (location) =>
              location.city_name &&
              (location.is_trending_active ?? true) &&
              location.imagePreview
          )
          .sort((left, right) => {
            const orderDifference = getTrendingOrder(left) - getTrendingOrder(right)

            if (orderDifference !== 0) {
              return orderDifference
            }

            return (left.city_name || '').localeCompare(right.city_name || '')
          })
      : []

    return {
      ...data,
      data: normalizedLocations,
    }
  }, [data])

  return {
    cities,
    loading,
    isError,
    error,
  }
}
